<script lang="ts">
  import { currentPostShortcode, surroundingPostShortcodes } from "./stores";
  import Thumbnail from "./Thumbnail.svelte";
  import { post_ids, image_index } from "./images.json";
  import Tip from "./help/Tip.svelte";
</script>

<nav>
  <ul>
    {#each $surroundingPostShortcodes as postID (postID)}
      <li>
        <Thumbnail {postID} selected={postID === $currentPostShortcode} />
      </li>
    {/each}
  </ul>

  {#if $currentPostShortcode}
    <div class="tip">
      <Tip>
        <p>click posts to open them &#11022;</p>
      </Tip>
    </div>
  {/if}
</nav>

<style>
  nav > ul {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    list-style: none;
  }

  div.tip {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    max-width: calc(100vw - 1rem);
  }

  p {
    margin: 0;
  }
</style>
